import { dataHexagonSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHexagonSolid = /*#__PURE__*/createIcon(dataHexagonSolid)
export default IconHexagonSolid
